import { useOutletContext } from "react-router-dom";
export const useDash = () => useOutletContext();

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  platform_admin: "Platform Admin",
  onboarding_admin: "Onboarding",
  operator: "Operator",
  company_admin: "Administrator",
  regional_manager: "Portfolio Manager",
  hoa_manager: "Community Manager",
  board_member: "Board Member",
};

export function fileUrl(path) {
  if (!path) return "";
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
}
